import { Box, Button, Checkbox, Container, CssBaseline, FormControlLabel, Grid, Paper, Snackbar, SnackbarContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import AdminNavigation from "./adminNavigation";
import { useEffect, useState } from "react";
import { btnStyleContrast, checkboxStyleContrast, subHeaderStyleContrast } from "../helper/style";
import AccessRightService from "../services/manager/accessRightService";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';


const AccessRight = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [msgSuccess, setMsgSuccess] = useState(null);
  const [showError, setShowError] = useState(false);
  const [msgError, setMsgError] = useState(null);
  const [accessRights, setAccessRights] = useState([]);
  const [loading, setLoading] = useState(false);

  const activateSuccess = (message) => {
    setMsgSuccess(message);
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  };

  const activateError = (message) => {
    setMsgError(message);
    setShowError(true);
    setTimeout(() => {
      setShowError(false);
    }, 5000);
  };

  const getListAccessRights = async () => {
    try {
      const response = await AccessRightService.getListAccessRights();
      if (response) {
        const data = response.data;
        setAccessRights(data.accessRightList);
      }
    } catch (error) {
      console.error("error");
      activateError("Gagal memuat data hak akses");
    }
  }

  const updateAccessRight  = async () => {
    try {
      setLoading(true);
      const response = await AccessRightService.updateAccessRight(accessRights);
      if (response) {
        const data = response.data;
        setAccessRights(data.accessRightList);

        activateSuccess("Berhasil ubah hak akses");
      }
    } catch (error) {
      const data = error.response.data;
      if (data) {
        activateError(data.message);
      } else {
        activateError("Gagal mengubah hak akses");
      }
    } finally {
      setLoading(false);
    }
  }

  const onchangeRight = (rights, key) => {
    setAccessRights(prevAccessRights => 
      prevAccessRights.map(item => 
        item.id === rights.id 
          ? {...item, [key]: !rights[key]} 
          : item
      )
    );
  }

  useEffect(() => {
    getListAccessRights();
  }, []);

  return (
    <Box>
      <CssBaseline />
      <AdminNavigation />
      <Container component="main" maxWidth="xl">
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={showSuccess}
          autoHideDuration={3000}
          onClose={() => setShowSuccess(false)}
        >
          <SnackbarContent
            sx={{ backgroundColor: "#19B600" }} 
            message={msgSuccess}/>
        </Snackbar>
  
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={showError}
          autoHideDuration={3000}
          onClose={() => setShowError(false)}
        >
          <SnackbarContent 
            sx={{ backgroundColor: "#E50B0B" }} 
            message={msgError}/>
        </Snackbar>

        <Grid container spacing={1} alignItems="center" marginBottom={2}>
          <Grid item xs={12}>
            <Typography sx={{ ...subHeaderStyleContrast }}>
              Hak Akses
            </Typography>
          </Grid>
        </Grid>

        <Box sx={{ marginY: "20px" }}>
          <TableContainer component={Paper}>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ textAlign: "center" }}>No.</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Posisi</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Absensi</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Data Karyawan</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Gaji Karyawan</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Pengaturan Karyawan</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Hak Akses</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Kelola Produk</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Kelola SKU</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Kelola Diskon</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Review Pesanan Lique</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Review Refund</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Kelola Brand</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Kelola Theme</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Kelola Mitra</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Review Pesanan</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Review Transaksi</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Penarikan Dana</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  accessRights.filter(rights => rights.position !== "Customer").map(rights => (
                    <TableRow key={rights.id}>
                      {
                        Object.keys(rights).map(key => (
                          <TableCell key={`${rights.id}-${key}`}>
                            {
                              ['id', 'position'].includes(key) ? rights[key] : (
                                <Box display="flex" justifyContent="center">
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={rights[key]}
                                        checked={rights[key]}
                                        onChange={() => onchangeRight(rights, key)}
                                        sx={{ ...checkboxStyleContrast }}
                                      />
                                    }
                                    sx={{ margin: "unset" }}
                                  />
                                </Box>
                              )
                            }
                          </TableCell>
                        ))
                      }
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          </TableContainer>

          <Grid container justifyContent="end" marginTop={3}>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <Button 
                sx={{ ...btnStyleContrast, borderRadius: "50px", width: "100%" }}
                startIcon={<EditOutlinedIcon />}
                disabled={loading}
                onClick={updateAccessRight}
              >
                { loading ? "Mohon menunggu..." : "Ubah Hak Akses"}
              </Button>
            </Grid> 
          </Grid>
        </Box>
      </Container>
    </Box>
  )
}

export default AccessRight;